import {
    CORE_CREATE_FLOOR_SUCCESS,
    CORE_CREATE_FLOOR_REQUEST,

    CORE_EDIT_FLOOR_SUCCESS,
    CORE_EDIT_FLOOR_REQUEST,

    CORE_LOAD_ALL_FLOOR_SUCCESS,
    CORE_LOAD_ALL_FLOOR_REQUEST,

    CORE_LOAD_FLOOR_SUCCESS,
    CORE_LOAD_FLOOR_REQUEST,

    CORE_DELETE_FLOOR_SUCCESS,
    CORE_DELETE_FLOOR_REQUEST,

    CORE_FILTER_FLOOR_REQUEST,
    CORE_FILTER_FLOOR_SUCCESS,
} from '../../types'

const initialState = []
export default {
    floor: (state = initialState, action) => {
        switch (action.type) {
            case CORE_CREATE_FLOOR_REQUEST:
            case CORE_LOAD_FLOOR_REQUEST:
            case CORE_EDIT_FLOOR_REQUEST:
            case CORE_DELETE_FLOOR_REQUEST:
                return initialState

            case CORE_CREATE_FLOOR_SUCCESS:
            case CORE_LOAD_FLOOR_SUCCESS:
            case CORE_EDIT_FLOOR_SUCCESS:
            case CORE_DELETE_FLOOR_SUCCESS:
                if (action.payload) {
                    return action.payload
                }
                else return {}

            default:
                return state
        }
    },
    floorsList:(state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ALL_FLOOR_REQUEST:
            case CORE_FILTER_FLOOR_REQUEST:
                return initialState

            case CORE_LOAD_ALL_FLOOR_SUCCESS:
            case CORE_FILTER_FLOOR_SUCCESS:
                if (action.payload) {
                    return action.payload
                }
                else return [{}]

            default:
                return state
        }
    },

}


// WEBPACK FOOTER //
// ./src/features/floors/reducer.js